import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-reset-password',
  imports: [ReactiveFormsModule],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.scss'
})
export class ResetPassword {
  private apiUrl = environment.apiBaseUrl;
  token = '';
  newPassword = '';
  confirmed = false;
  invalid = false;

  route = inject(ActivatedRoute)
  http = inject(HttpClient)
  router = inject(Router)

  updatePassForm = new FormGroup({
    password: new FormControl('')
  });
  constructor() {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (this.token) {
      this.http.get(this.apiUrl + `/verify-reset-token?token=${this.token}`).subscribe({
        error: () => (this.invalid = true),
      });
    } else {
      this.invalid = false;
    }
  }

  updatePassword() {
    this.http.post(this.apiUrl + '/update-password', { token: this.token, new_password: this.updatePassForm.value.password! }).subscribe({
      next: () => (this.confirmed = true),
      error: () => (this.invalid = true),
    });
  }
}
